// ─── layout.js ────────────────────────────────────────────────────────────────
// Paginaopmaak: header, footer, KPI-blokken, CSS, herhalende koptekst.
// Wijzig hier bij aanpassingen aan de paginastructuur.

import { fmtK } from './helpers.js';

function header(titel, meta, bedrijfsnaam, logo) {
  return `
    <div style="display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #1a364c;padding-bottom:8px;margin-bottom:12px;">
      <!-- Links: klant -->
      <div style="display:flex;align-items:center;gap:14px;">
        ${logo
          ? `<img src="${logo}" alt="${bedrijfsnaam}" style="max-height:56px;max-width:140px;object-fit:contain;display:block;"/>`
          : `<div style="width:48px;height:48px;border-radius:8px;background:#1a364c;display:flex;align-items:center;justify-content:center;font-size:22px;font-weight:800;color:white;flex-shrink:0;">${bedrijfsnaam.charAt(0).toUpperCase()}</div>`
        }
        <div>
          <div style="font-size:20px;font-weight:800;color:#1a364c;letter-spacing:-.4px;">${bedrijfsnaam}</div>
          <div style="font-size:14px;font-weight:600;color:#64748b;margin-top:2px;">${titel}</div>
          <div style="font-size:10px;color:#94a3b8;margin-top:2px;">${meta}</div>
        </div>
      </div>
      <!-- Rechts: SendWell + datum -->
      <div style="text-align:right;padding-top:4px;">
        <div style="font-size:11px;font-weight:600;color:#94a3b8;letter-spacing:.04em;">Verzorgd door</div>
        <div style="font-size:14px;font-weight:700;color:#1a364c;margin-top:1px;">SendWell</div>
        <div style="font-size:9px;color:#94a3b8;margin-top:2px;letter-spacing:.04em;">Transport Management</div>
        <div style="font-size:9px;color:#94a3b8;margin-top:4px;">${new Date().toLocaleDateString('nl-NL',{day:'numeric',month:'long',year:'numeric'})}</div>
      </div>
    </div>`;
}

function kpiBlok(items, cols=4) {
  return `
    <div style="display:grid;grid-template-columns:repeat(${cols},1fr);gap:10px;margin-bottom:14px;">
      ${items.map(({lbl,val,sub,kleur})=>`
        <div style="border:1px solid #e2e8f0;border-top:3px solid ${kleur||'#1a364c'};border-radius:8px;padding:10px 12px;">
          <div style="font-size:8px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:.05em;margin-bottom:5px;">${lbl}</div>
          <div style="font-size:15px;font-weight:800;color:#1a364c;letter-spacing:-.3px;line-height:1.2;word-break:break-word;">${val}</div>
          ${sub?`<div style="font-size:9px;color:#64748b;margin-top:3px;">${sub}</div>`:''}
        </div>`).join('')}
    </div>`;
}

function pageCss(orientatie) {
  const liggend = (orientatie||'staand') === 'liggend';
  return `
    @page {
      size: A4 ${liggend?'landscape':'portrait'};
      margin: ${liggend?'8mm 10mm':'14mm 12mm'};
    }
    body { font-size: ${liggend?'9':'10'}px; margin: 0; }
    /* Blokken nooit doorsnijden */
    .blok, figure, .grafiek { page-break-inside: avoid; break-inside: avoid; }
    /* Sectietitel altijd bij zijn inhoud houden */
    .sectie-titel { page-break-after: avoid; break-after: avoid; }
    /* Herhaal koptekst via thead */
    thead.herhaal-kop { display: table-header-group; }
    /* Paginanummering rechtsonder */
    .paginanummer {
      position: fixed;
      bottom: 6mm;
      right: 10mm;
      font-size: 8px;
      color: #94a3b8;
      font-family: -apple-system, Arial, sans-serif;
    }
  `;
}

function sectTitelKlein(t) {
  return `<div style="font-size:9px;font-weight:700;color:#1a364c;text-transform:uppercase;letter-spacing:.06em;border-bottom:1px solid #e2e8f0;padding-bottom:3px;margin:0 0 6px;">${t}</div>`;
}

function sectTitel(t) {
  return `<div class="sectie-titel" style="font-size:9px;font-weight:700;color:#1a364c;text-transform:uppercase;letter-spacing:.07em;border-bottom:1px solid #e2e8f0;padding-bottom:4px;margin:14px 0 8px;page-break-after:avoid;break-after:avoid;">${t}</div>`;
}

function footer() {
  return `<div style="margin-top:28px;padding-top:8px;border-top:1px solid #e8edf3;font-size:9px;color:#94a3b8;text-align:center;">
    SendWell BV · Transport Management System · Vertrouwelijk document
  </div>`;
}

function wrapMetHerhalendeHeader(cssStyle, headerHtml, bodyHtml) {
  return `
    ${cssStyle}
    <style>
      /* Paginanummer rechtsonder op elke pagina */
      @media print {
        .paginanummer { display: block !important; }
      }
      .paginanummer {
        display: none;
        position: fixed;
        bottom: 5mm;
        right: 8mm;
        font-size: 8px;
        color: #94a3b8;
        font-family: -apple-system, Arial, sans-serif;
      }
    </style>
    <!-- Herhalende koptekst via thead-techniek (werkt in alle browsers) -->
    <table style="width:100%;border-collapse:collapse;table-layout:fixed;border:none;">
      <thead>
        <tr>
          <td style="padding:0 0 12px 0;border:none;">
            ${headerHtml}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="padding:0;border:none;">
            ${bodyHtml}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td style="padding:0;border:none;">
            <div style="text-align:center;font-size:8px;color:#94a3b8;padding-top:8px;border-top:1px solid #f1f5f9;">
              SendWell BV · Transport Management System · Vertrouwelijk document
            </div>
          </td>
        </tr>
      </tfoot>
    </table>`;
}


export { header, kpiBlok, pageCss, sectTitelKlein, sectTitel, footer, wrapMetHerhalendeHeader };
